import React from 'react';
import SessionManager from '../../routes/SessionManager';
import Threshold from './Threshold';

class Activity extends React.Component {

    constructor(props) {
        super(props);
        let sessionMgr = new SessionManager();
        let user = sessionMgr.readCookie('user');



        this.state = { refresh_id: this.props.refresh_id, user: user, activity: this.props.activity, sensor_types: this.getSensorTypes(props) };
        //console.log('Activity#Refresh in progress ...');
        //console.log('activity', this.props.activity);
    }

    getSensorTypes = (props) => {
        let sensor_types = new Set();
        sensor_types.add("temperature");
        sensor_types.add("humidity");
        sensor_types.add("battbackup");

        if (props && props.sensors) {
            for (let s of props.sensors) {
                switch (s.sensor_type) {
                    case 'RSLT':
                        sensor_types.add("temperature");
                        sensor_types.add("humidity");
                        break;

                    case 'RSCO':
                        sensor_types.add("co");
                        sensor_types.add("co2");
                        break;

                    case 'WATERLEAK':
                        sensor_types.add("leak");
                        break;

                    case 'WATERFLOW':
                        sensor_types.add("flow");
                        break;

                    default:
                        break;
                }
            }
        }
        return sensor_types;
    }

    shouldComponentUpdate(nextProps, nextState) {
        //console.log('Activity#shouldComponentUpdate ...');
        if (this.state.activity.activity_id !== nextProps.activity.activity_id) {
            //console.log('updating values ...');
            this.setState({ activity: nextProps.activity, sensor_types: this.getSensorTypes(nextProps) });
        }

        if (JSON.stringify(nextProps.sensors) !== JSON.stringify(this.props.sensors)) {
            this.setState({ sensor_types: this.getSensorTypes(nextProps) });
        }
        return true;
    }

    addOrRemove = (thresholdModified) => {
        //console.log('Activity#OnChange', thresholdModified);
        let activity = JSON.parse(JSON.stringify(this.state.activity));
        var i = 0;
        for (let threshold of activity.activity_thresh_json) {
            if (threshold.sensor_id === thresholdModified.sensor_id) {
                activity.activity_thresh_json[i] = thresholdModified;
                break;
            }
            i++;
        }

        this.setState({ activity: activity }, function () {
            this.props.onChange(thresholdModified);
        });
    }

    render() {
        console.log('sensor types', this.state.sensor_types);
        console.log('this.state.activity.activity_thresh_json', this.state.activity.activity_thresh_json)
        return this.state.activity && this.state.activity.activity_scope === 0 ?
            (
                <React.Fragment >
                    <br />
                    <span className="px-2 text-procore pt-5">Zones Specific Alerts:</span>
                    <div className="pt-2">
                        <div className="row"><div className="col-md-12 p-2"><span className="ml-3"><i className="fa fa-info-circle text-primary"></i> <span className="font-size-12"><i>Default Alert Notification: Every 3 hours.</i></span></span></div></div>
                        {this.props.showClimate ?
                            (<div className="row">
                                {
                                    this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                        return (threshold.default !== true) && ['temperature', 'humidity', 'motion', 'vmotion_ahours', 'battbackup'].indexOf(threshold.sensor_id) !== -1 ? <div key={index} className="col-md-6">
                                            <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                        </div>
                                            : ''
                                    })
                                }
                                {
                                    this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                        return (threshold.default === true) && ['temperature', 'humidity', 'motion', 'vmotion_ahours', 'battbackup'].indexOf(threshold.sensor_id) !== -1 ? <div key={index} className="col-md-12">
                                            <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                        </div>
                                            : ''
                                    })
                                }
                            </div>) :
                            (<div className="row">
                                {
                                    this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                        return (threshold.default !== true) && ['motion', 'vmotion_ahours', 'battbackup'].indexOf(threshold.sensor_id) !== -1 ? <div key={index} className="col-md-6">
                                            <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                        </div>
                                            : ''
                                    })
                                }
                                {
                                    this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                        return (threshold.default === true) && ['motion', 'vmotion_ahours', 'battbackup'].indexOf(threshold.sensor_id) !== -1 ? <div key={index} className="col-md-12">
                                            <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                        </div>
                                            : ''
                                    })
                                }
                            </div>)}
                    </div>
                </React.Fragment>
            ) :
            (this.props.showRSCOthreshold || this.props.weatherAlerts ?
                <React.Fragment>
                    <div className="row">
                        {
                            this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                return (threshold.default !== true) ? <div key={index} className="col-md-6">
                                    <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                </div>
                                    : ''
                            })
                        }
                        {
                            this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                return (threshold.default === true) ? <div key={index} className="col-md-12">
                                    <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                </div>
                                    : ''
                            })
                        }
                    </div>
                </React.Fragment> :
                <React.Fragment>
                    <br />
                    <div className="row">
                        {
                            this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                return (threshold.default !== true) && this.state.sensor_types.has(threshold.sensor_id) && ['temperature', 'humidity', 'leak', 'flow'].includes(threshold.sensor_id) ? <div key={index} className="col-md-6">
                                    <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                </div>
                                    : ''
                            })
                        }
                        {
                            this.state.activity && this.state.activity.activity_thresh_json.map((threshold, index) => {
                                return (threshold.default === true) && this.state.sensor_types.has(threshold.sensor_id) && ['temperature', 'humidity', 'leak', 'flow'].includes(threshold.sensor_id) ? <div key={index} className="col-md-12">
                                    <Threshold key={this.state.activity.activity_id + index} onChange={this.props.onChange} pos={index} threshold={threshold} addOrRemove={this.addOrRemove}></Threshold>
                                </div>
                                    : ''
                            })
                        }
                    </div>
                </React.Fragment>
            )

    }
}

export default Activity;